













































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
@Component({
  name: "ui-text-editor"
})
export default class UiTextEditorComponent extends Vue {
  @Prop({ type: String,  default: "extended" })        type: string;
  @Prop({ type: String,  default: "" })         placeholder: string;
  @Prop({ type: String,  default: "" })               value: string;
  @Prop({ type: Boolean, default: true })         stripHtml: boolean;
  @Prop({ type: String,  default: "100px"})      minHeight: string;
  // @Prop({ type: Boolean, default: true }) hasImage: boolean;
  // @Prop({ type: String }) savedImage: string;
  // pasteImageRange: Range = null;
  stretchDraft = false;
  rawHtml = this.value;
  scrollStyle = {
    bottom: "0px"
  };
  created() {
    //this.fetchData();
    // console.log("Йа эдитор");
  }
  @Watch("value")
  onValueChanged() {
    if ((this.$refs.editor as HTMLElement).innerHTML !== this.value) {
      // console.log("updated value");
      this.rawHtml = this.value;
    }
  }
  fetch() {}

  onPressCtrEnter(){
    this.$emit("ctrlEnter",this.value)
  }
  handlePaste(e: ClipboardEvent) {
    // console.log("paste");
    if (this.stripHtml) {
      this.pasteText(e);
      this.update(e);
    }
  }
  pasteText(e: ClipboardEvent) {
    var clipboardData, pastedData;
    e.stopPropagation();
    e.preventDefault();
    clipboardData = e.clipboardData || (window as any).clipboardData;
    pastedData = clipboardData.getData("Text");
    this.processPaste(pastedData);
  }

  processPaste(pastedData: string) {
    const textFragments = pastedData.split(/\r?\n/);
    const textFragment = document.createDocumentFragment();
    textFragments.forEach((text, index) => {
      const textNode = document.createTextNode(text);
      textFragment.appendChild(textNode);
      if (index < textFragments.length - 1) {
        textFragment.appendChild(document.createElement("br"));
      }
    });

    if (window.getSelection) {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      range.insertNode(textFragment);
      range.collapse(false);
    }
  }

  wysiwygFormat(command: string) {
    if (command == "h3" || command == "h2") {
      document.execCommand("formatBlock", false, command);
    }
    // if (command == "insertImage") {
    //   this.loadImage();
    //   return;
    // }
    if (command == "createlink") {
      let url = prompt("Enter the link here: ", "http://");
      document.execCommand(command, false, url);
    } else document.execCommand(command, false, null);
  }
  stretchWysiwyg() {
    this.stretchDraft = !this.stretchDraft;
  }
  manualUpdate(text: string) {
    this.$emit("input", text);
  }
  update(event: ClipboardEvent) {
    this.manualUpdate((event.target as HTMLElement).innerHTML);
  }
  clear() {
    var el = this.$el.querySelector("#editor");
    if (!el) return;
    el.innerHTML = "";
    this.rawHtml = "";
    this.$emit("input", "");
  }
  setActive() {
    (this.$refs.editor as HTMLElement).focus();
  }
  /**
   * Отслеживаем потерю фокуса, бросаем дальше событие потери фокуса, когда курсор не находится над компонентом
   */
  lossFocus() {
    if (!this.mouseOvered) {
      this.$emit('lossFocus');
    }
  }
  /**
   * Флаг показывающий где находится курсор над компонентом или вне его
   */
  onMouseOver() {
    this.mouseOvered = true;
  }
  onMouseOut() {
    this.mouseOvered = false;
  }
  // @Watch('savedImage')
  // onSavedImageChanged(newValue: string, oldValue: string) {
  //   if (newValue == null) {
  //     return;
  //   }
  //   (this.$refs.imageLoader as any).hide();
  //   const imageNode = document.createElement("img");
  //   imageNode.src = newValue;
  //   imageNode.style.width = "100%";
  //   if (this.pasteImageRange) {
  //     this.pasteImageRange.insertNode(document.createElement("br"));
  //     this.pasteImageRange.insertNode(imageNode);
  //     //this.pasteImageRange.insertNode(document.createElement("br"));
  //     this.lastSelection = null;
  //   } else {
  //     const wrapper = document.createElement('div');
  //     wrapper.appendChild(imageNode)
  //     this.$refs.editor.appendChild(wrapper);
  //     this.$refs.editor.appendChild(document.createElement("br"));
  //   }

  //     this.manualUpdate(this.$refs.editor.innerHTML);
  // }
  // loadImage() {
  //   if (window.getSelection) {
  //     const lastSelection = window.getSelection();
  //     if (lastSelection.rangeCount > 0) {
  //       this.pasteImageRange = lastSelection.getRangeAt(0).cloneRange();
  //     }
  //   }
  //   this.$refs.imageLoader.show();
  // },
  // saveImage(...args) {
  //   this.$emit("saveImage", ...args);
  // },
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-text-editor/src/ui-text-editor.vue